<template>
  <div class="" style="background-color: #f7f7f7; min-height: 100vh">
    <van-sticky>
      <van-dropdown-menu>
        <van-dropdown-item
          v-model="value1"
          :options="option1"
          @change="getValue1"
        />
        <van-dropdown-item
          v-model="value2"
          :options="option2"
          @change="getValue2"
        />
      </van-dropdown-menu>
    </van-sticky>
    <div style="padding-bottom: 100px; padding-top: 12px">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          offset="10"
          :finished="finished"
          finished-text="没有更多了 ~"
          @load="onLoad"
          :immediate-check="false"
        >
          <div class="box" v-for="(item, index) in list" :key="index">
            <div style="display: flex; margin-bottom: 5px">
              <div class="evaluateListLeft">
                <div>
                  <!-- 平台 头像 -->
                  <!-- <img
                src="https://alyimg-zhyl.anluoyun.cn/xaxmzj/images/1703839551957.png"
              /> -->
                  <img :src="item.headImgUrl" alt="" />
                </div>
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                  "
                >
                  <div class="nickName">
                    {{ item.nickName }}
                  </div>
                  <div class="time">{{ item.create_time | formatTime }}</div>
                </div>
              </div>
              <div
                style="
                  width: 40%;
                  text-align: right;
                  line-height: 40px;
                  font-family: Price;
                  font-weight: 500;
                  font-size: 20px;
                  color: #f36e86;
                "
              >
                <span style="font-size: 12px">￥</span
                >{{ item.price.toFixed(2) }}
              </div>
            </div>
            <div
              class="delete"
              @click="deleteDemand(item)"
              v-if="item.status == 1 && item.userId == userId"
            >
              <van-icon name="cross" color="#fff" size="12" />
            </div>
            <div class="isLike">
              <span style="margin-right: 5px">需求类型</span
              ><van-tag
                type="warning"
                plain
                style="margin-right: 10px; background-color: #fff4e5"
                >{{ item.demandName }}</van-tag
              >
              <span style="margin-right: 5px">权限类型</span
              ><van-tag type="danger" plain style="background-color: #ffedee">{{
                item.authName
              }}</van-tag>
            </div>
            <div
              @click="gotoXq(item)"
              style="
                width: 100%;
                background: #f7f7f7;
                border-radius: 8px;
                box-sizing: border-box;
                padding: 14px 12px 12px;
                position: relative;
              "
            >
              <div class="nickName" style="font-size: 16px">
                <span class="van-ellipsis" style="flex: 1">{{
                  item.name
                }}</span>
                <span style="font-size: 13px; color: #666">{{
                  item.create_time
                }}</span>
              </div>
              <div
                v-if="item.content"
                class="content van-ellipsis--l2"
                v-html="item.content"
              ></div>
            </div>
            <button
              v-if="item.status == 1 && item.userId != userId"
              class="grabbing"
              @click="handleGrabbing(item)"
            >
              抢单
            </button>
            <button
              v-if="item.status == 2"
              class="grabbing"
              style="background-color: #f7f7f7; border-color: #eee; color: #666"
              @click="handleStatus2"
            >
              已被抢单
            </button>
            <button
              v-if="item.status == 3"
              class="grabbing"
              style="background-color: #f7f7f7; border-color: #eee; color: #666"
              @click="handleStatus3"
            >
              已成单
            </button>
            <button
              v-if="item.status == 4"
              class="grabbing"
              style="background-color: #f7f7f7; border-color: #eee; color: #666"
              @click="handleStatus4"
            >
              已完成
            </button>
            <!-- <div style="margin-top: 10px" v-if="item.img">
          <span v-if="item.img.split(',').length == 1">
            <img
              @click="showImagePreview(k, item.img.split(','))"
              @change="onChangeImg"
              v-for="(j, k) in item.img.split(',')"
              :key="k"
              class="images"
              :src="j"
              style="width: 180px; object-fit: cover"
            />
          </span>
          <span v-else style="display: flex; flex-wrap: wrap">
            <img
              @click="showImagePreview(k, item.img.split(','))"
              @change="onChangeImg"
              v-for="(j, k) in item.img.split(',')"
              :key="k"
              class="images"
              :src="j"
              :style="{
                width: (windowWidth - 30) * 0.3 + 'px',
                height: (windowWidth - 30) * 0.3 + 'px',
              }"
              style="object-fit: cover"
            />
          </span>
        </div> -->
          </div>
        </van-list>
      </van-pull-refresh>

      <div class="backTop" @click="add">
        <img
          src="https://alyimg-zhyl.anluoyun.cn/xaxmzj/images/1703829933734.png"
          class="top_image"
        />
      </div>
      <!-- <van-empty v-if="list.length == 0" description="暂无数据" /> -->
    </div>
    <!-- 预览轮播图 -->
    <van-image-preview
      v-model="ImagePreviewShow"
      :images="ImgsList"
      :start-position="this.current"
      @change="onChangeImagePreview"
      @close="closeImagePreview"
    >
    </van-image-preview>

    <div class="fixed">
      <button class="bottomBtn" @click="orderList">订单列表</button>
    </div>
  </div>
</template>

<script>
import {
  setOpenId,
  setUrl,
  setPlatform,
  setIntegral,
  setStoreId,
  getStoreId,
  getOpenId,
  getUrl,
} from "@/utils/auth";
import {
  getDemandType,
  getAuthType,
  getDemandList,
  insertGrabbing,
  getAuth,
  deleteDemand,
} from "@/api/demand.js";
import { Dialog, Toast } from "vant";
export default {
  // 组件名称
  name: "",
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {},
  // 组件状态值
  data() {
    return {
      refreshing: false,
      userId: "",
      loading: false, //加载
      finished: false, //数据完全加载结束为 true
      ImgsList: [],
      ImagePreviewShow: false,
      index: 0,
      current: 0,
      list: [],
      value1: "",
      value2: "",
      option1: [{ text: "全部", value: "" }],
      option2: [{ text: "全部", value: "" }],
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        platformId: this.$route.query.platformId,
        url: "",
        authType: "",
        demandType: "",
      },
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度
      storePhone: "",
      isDresser: "",
      isPhotography: "",
      isStylist: "",
    };
  },
  filters: {
    formatTime(time, option) {
      //将获取到的时间转换成时间戳
      var timestamp = Date.parse(new Date(time));
      if (("" + timestamp).length === 10) {
        timestamp = parseInt(timestamp) * 1000;
      } else {
        timestamp = +timestamp;
      }
      const d = new Date(timestamp);
      const now = Date.now();

      const diff = (now - d) / 1000;

      if (diff < 30) {
        return "刚刚";
      } else if (diff < 3600) {
        // less 1 hour
        return Math.ceil(diff / 60) + "分钟前";
      } else if (diff < 3600 * 24) {
        return Math.ceil(diff / 3600) + "小时前";
      } else if (diff < 3600 * 24 * 2) {
        return "1天前";
      }
      return (
        d.getFullYear() +
        "年" +
        (d.getMonth() + 1) +
        "月" +
        d.getDate() +
        "日" +
        d.getHours() +
        "时" +
        d.getMinutes() +
        "分"
      );
    },
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  // 组件方法
  methods: {
    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad1();
    },
    onLoad1() {
      setTimeout(() => {
        if (this.refreshing) {
          this.list = [];
          this.refreshing = false;
        }
        this.queryParams.pageNum = 1;
        this.getList();
      }, 1000);
    },
    // 发布需求
    add() {
      this.gotoUrl("/demand/addDemand");
    },
    // 获取店铺信息
    getStoreInfo() {
      var that = this;
      const axios = require("axios");
      const apiUrl = getUrl() + "pointsMall/storeInfo";
      const params = { storeId: getStoreId() };
      // 发起 GET 请求，并将参数作为查询字符串传递
      axios
        .get(apiUrl, { params })
        .then((response) => {
          // 处理接口返回的数据
          console.log(response.data);
          that.storePhone = response.data.data.telephone;
        })
        .catch((error) => {
          // 处理错误
          console.error(error);
        });
    },
    // 获取用户信息
    getUserInfo() {
      var that = this;
      const axios = require("axios");
      const apiUrl = getUrl() + "pointsMall/userInfo";
      const params = { userId: getOpenId() };
      // 发起 GET 请求，并将参数作为查询字符串传递
      axios
        .get(apiUrl, { params })
        .then((response) => {
          // 处理接口返回的数据
          console.log(response.data);
          that.storePhone = response.data.data.phone;
        })
        .catch((error) => {
          // 处理错误
          console.error(error);
        });
    },
    // 获取用户信息
    getUserInfo1() {
      var that = this;
      const axios = require("axios");
      const apiUrl = getUrl() + "pointsMall/userInfo";
      const params = { userId: getOpenId() };
      // 发起 GET 请求，并将参数作为查询字符串传递
      axios
        .get(apiUrl, { params })
        .then((response) => {
          // 处理接口返回的数据
          console.log(response.data);
          that.isDresser = response.data.data.isDresser;
          that.isPhotography = response.data.data.isPhotography;
          that.isStylist = response.data.data.isStylist;
        })
        .catch((error) => {
          // 处理错误
          console.error(error);
        });
    },
    // 删除
    deleteDemand(row) {
      console.log(row);
      var that = this;
      Dialog.confirm({
        title: "温馨提示",
        message: "是否确认删除?",
      })
        .then(() => {
          Toast("确定啦");
          deleteDemand(row.id).then((res) => {
            Toast.success("删除成功");
            that.queryParams.pageNum = 1;
            that.list = [];
            that.getList();
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    // 抢单
    handleGrabbing(row) {
      var that = this;
      var grabbingId = "";
      if (getStoreId() && getStoreId() != "null") {
        grabbingId = getStoreId();
      } else {
        grabbingId = "";
      }
      getAuth({
        dataAuth: row.authName,
        storeId: grabbingId,
        isPhotography: that.isPhotography,
        isDresser: that.isDresser,
        isStylist: that.isStylist,
      }).then((res) => {
        console.log(res.data);
        if (res.data == 1) {
          // 有权限
          Dialog.confirm({
            title: "温馨提示",
            message: "是否确认抢单?",
          })
            .then(() => {
              var grabbingId = "";
              var userType = "";
              if (getStoreId() && getStoreId() != "null") {
                grabbingId = getStoreId();
                userType = 2;
              } else {
                grabbingId = getOpenId();
                userType = 1;
              }
              // on confirm
              insertGrabbing({
                demandId: row.id,
                userId: grabbingId,
                userType: userType,
                phone: that.storePhone,
              }).then(() => {
                Toast.success("抢单成功");
                that.queryParams.pageNum = 1;
                that.list = [];
                that.getList();
              });
            })

            .catch(() => {
              // on cancel
            });
        } else {
          // 无权限
          Toast("暂无抢单权限");
        }
      });
    },
    handleStatus2() {
      Toast("该订单已有人抢单");
    },
    handleStatus3() {
      Toast("该订单已成单");
    },
    handleStatus4() {
      Toast("该订单已完成");
    },
    // 订单列表
    orderList() {
      this.gotoUrl("/demand/orderList");
    },
    // 需求详情
    gotoXq(row) {
      this.gotoUrl("/demand/detail/" + row.id);
    },
    // 跳转
    gotoUrl(path) {
      if (window.__wxjs_environment === "miniprogram") {
        // 页面 不会重新加载
        window.wx.miniProgram.navigateTo({
          url: "../public/goto?path=" + path,
        });
      } else {
        // 页面会 重新加载(如:列表页 查看详情后会返回顶部)
        this.$router.push(path);
      }
    },
    // 筛选需求类型
    getValue1(val) {
      console.log(val);
      this.queryParams.demandType = val;
      this.list = [];
      this.queryParams.pageNum = 1;
      this.getList();
    },
    // 筛选权限类型
    getValue2(val) {
      console.log(val);
      this.queryParams.authType = val;
      this.list = [];
      this.queryParams.pageNum = 1;
      this.getList();
    },
    //得到图片索引值
    onChangeImg(index) {
      this.index = index;
    },
    //显示预览图
    showImagePreview(index, arr) {
      this.ImgsList = arr;
      this.ImagePreviewShow = true;
      this.current = index;
    },
    onChangeImagePreview(index) {
      this.index = index;
    },
    //关闭预览图
    closeImagePreview(info) {
      this.current = info.index;
    },
    // 获取权限类型
    async getDemandTypeList() {
      const res = await getDemandType({
        pageNum: 1,
        pageSize: 999,
      });
      var arr = res.data.data.list;
      //旧key到新key的映射
      var keyMap = {
        name: "text",
        id: "value",
      };
      for (var i = 0; i < arr.length; i++) {
        var obj = arr[i];
        for (var key in obj) {
          var newKey = keyMap[key];
          if (newKey) {
            obj[newKey] = obj[key];
            delete obj[key];
          }
        }
      }
      var Arr = this.option1.concat(arr);
      this.option1 = Arr;
    },
    // 获取需求类型
    async gegetAuthTypeList() {
      const res = await getAuthType({
        pageNum: 1,
        pageSize: 999,
      });
      var arr = res.data.data.list;
      //旧key到新key的映射
      var keyMap = {
        name: "text",
        id: "value",
      };
      for (var i = 0; i < arr.length; i++) {
        var obj = arr[i];
        for (var key in obj) {
          var newKey = keyMap[key];
          if (newKey) {
            obj[newKey] = obj[key];
            delete obj[key];
          }
        }
      }
      var Arr = this.option2.concat(arr);
      this.option2 = Arr;
    },
    // 下拉刷新
    onLoad() {
      console.log("到底啦");
      // this.list = [];
      this.queryParams.pageNum = this.queryParams.pageNum + 1;
      this.getList();
    },
    // 获取需求列表
    async getList() {
      this.loading = true;
      console.log(this.loading);
      getDemandList(this.queryParams).then((res) => {
        if (res.data.code == 200) {
          console.log(res);
          let rows = res.data.data.list;
          this.list = this.list.concat(rows);
          console.log(this.list);
          this.loading = false;
          if (!res.data.data.hasNextPage) {
            // 加载结束 => 没有下一页
            console.log("结束");
            this.finished = true;
          } else {
            this.finished = false;
          }
        } else {
          this.finished = true;
        }
      });
    },
  },
  created() {
    // 获取并保存openid
    if (this.$route.query["openId"]) {
      setOpenId(this.$route.query["openId"]);
    }
    console.log(this.$route);
    this.integral = this.$route.query.integral;
    setUrl(this.$route.query.url);
    setPlatform(this.$route.query.platformId);
    setIntegral(this.$route.query.integral);
    setStoreId(this.$route.query.storeId);
    if (getStoreId() && getStoreId() != "null") {
      // 有店铺ID =>拿店铺的 手机号
      this.getStoreInfo();
      this.userId = getStoreId();
    } else {
      // openId => 拿用户的 手机号
      this.getUserInfo();
      this.userId = getOpenId();
    }
    this.getUserInfo1();
  },
  mounted() {
    var str = this.$route.query.url;
    this.queryParams.url = this.$route.query.url.slice(0, str.length - 1);
    this.getDemandTypeList();
    this.gegetAuthTypeList();
    this.getList();
    console.log(this.windowWidth, "windowWidth");
  },
};
</script>

<style scoped>
@font-face {
  font-family: "Price";
  src: url(../../assets/font/OPPOSANS-H.TTF);
}
.box {
  box-sizing: border-box;
  padding: 14px 10px 10px;
  background-color: #fff;
  width: 95%;
  margin: auto;
  border-radius: 8px;
  margin-bottom: 12px;
  position: relative;
}

.evaluateListBox {
  margin: 7px 5px;
  border-bottom: 1px solid #f5f5f5;
}

.evaluateListLeft {
  width: 70%;
  display: flex;
}

.evaluateListLeft img {
  width: 40px;
  height: 40px;
  border-radius: 40px;
  margin-right: 8px;
}

.isLike {
  margin: 10px 0;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #999;
  position: relative;
}

.grabbing {
  width: 100%;
  height: 35px;
  line-height: 35px;
  background: #f36e8629;
  border-radius: 17px;
  border: none;
  font-family: PingFang SC;
  font-weight: bold;
  font-size: 13px;
  color: #f36e86;
  margin-top: 15px;
  border: 1px solid #f36e86;
}
.images {
  border-radius: 5px;
  margin: 0px 5px 5px 0;
}

.backTop {
  display: flex;
  position: fixed;
  bottom: 125px;
  right: 10px;
  width: 75px;
  height: 75px;
}

.top_image {
  width: 75px;
  height: 75px;
}

.time {
  font-size: 12px;
  font-family: PingFang SC;
  color: #999999;
}

icon {
  font-size: 10px;
}

.van-dropdown-menu__title,
.van-dropdown-item__option {
  font-family: PingFang SC;
}

.nickName {
  display: flex;
  justify-content: space-between;
  align-content: center;
  font-size: 14px;
  font-family: PingFang SC;
  color: #1e1e1e;
}

.van-tag {
  font-size: 10px !important;
  font-family: PingFang SC;
  padding: 2px 5px 1px !important;
  border-radius: 3px !important;
}

.fixed {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 60px;
  background-color: #fff;
  box-shadow: 0 -2px 10px 0 rgba(0, 0, 0, 0.08);
  z-index: 100;
  text-align: center;
}

.bottomBtn {
  background: #f36e86;
  border-radius: 22px;
  border: none;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #fff;
  width: 94%;
  padding: 11.5px 0;
  margin-top: 7.5px;
}

.content {
  font-size: 14px;
  color: #666;
  margin-top: 10px;
}
.van-ellipsis--l2 {
  display: -webkit-box !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  -webkit-line-clamp: 2 !important;
  -webkit-box-orient: vertical !important;
}

.delete {
  position: absolute;
  top: 0;
  right: 0;
  width: 18px;
  height: 18px;
  line-height: 18px;
  background: #f36e86;
  border-radius: 0px 8px 0px 8px;
  text-align: center;
}
</style>

<style>
p {
  display: block;
  -webkit-margin-before: 0em;
  -webkit-margin-after: 0em;
  -webkit-margin-start: 0px;
  -webkit-margin-end: 0px;
}
</style>
